import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import { Info, Close } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  PolypaneIntro,
  Info,
  Close,
  React
};